export default "__VITE_ASSET__Z$x4LYUy__"